import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faMoneyBillWave,
  faExchangeAlt,
  faChartLine,
  faRefresh
} from '@fortawesome/free-solid-svg-icons';

// ✅ ADD THIS (same as your working DashboardPage):
const API_BASE_URL = "https://final-project-5ar7.onrender.com";

console.log('🌐 ADMIN DASHBOARD API_BASE_URL:', API_BASE_URL);

function AdminDashboard() {
  const [stats, setStats] = useState([
    { title: 'Total Users', value: '0', color: '#3b82f6', icon: faUsers },
    { title: 'Pending Registrations', value: '0', color: '#f59e0b', icon: faMoneyBillWave },
    { title: 'Approved Users', value: '0', color: '#1fa84f', icon: faExchangeAlt },
    { title: 'Active Trading Accounts', value: '0', color: '#ef4444', icon: faChartLine }
  ]);
  
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    try {
      setLoading(true);
      
      const token = localStorage.getItem("userToken");
      
      console.log('📡 Fetching from:', `${API_BASE_URL}/api/admin/public/dashboard-stats`);
      
      const statsResponse = await fetch(`${API_BASE_URL}/api/admin/public/dashboard-stats`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        }
      });
      
      if (!statsResponse.ok) {
        throw new Error(`HTTP ${statsResponse.status}: ${statsResponse.statusText}`);
      }
      
      const statsData = await statsResponse.json();
      
      console.log('✅ Dashboard stats loaded:', statsData);
      
      // Update stats with real data from backend
      setStats([
        { 
          title: 'Total Users', 
          value: statsData.totalUsers?.toLocaleString() || '0', 
          color: '#3b82f6', 
          icon: faUsers 
        },
        { 
          title: 'Pending Registrations', 
          value: statsData.pendingUsers?.toString() || '0', 
          color: '#f59e0b', 
          icon: faMoneyBillWave 
        },
        { 
          title: 'Approved Users', 
          value: statsData.approvedUsers?.toString() || '0', 
          color: '#1fa84f', 
          icon: faExchangeAlt 
        },
        { 
          title: 'Active Trading Accounts', 
          value: statsData.activeAccounts?.toString() || '0', 
          color: '#ef4444', 
          icon: faChartLine 
        }
      ]);
      
    } catch (error) {
      console.error('❌ Failed to fetch dashboard stats:', error);
      // Keep default values if API fails
      setStats([
        { title: 'Total Users', value: 'Error', color: '#3b82f6', icon: faUsers },
        { title: 'Pending Registrations', value: 'Error', color: '#f59e0b', icon: faMoneyBillWave },
        { title: 'Approved Users', value: 'Error', color: '#1fa84f', icon: faExchangeAlt },
        { title: 'Active Trading Accounts', value: 'Error', color: '#ef4444', icon: faChartLine }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '0' }}>
        <div style={{ 
          background: 'white',
          padding: '30px',
          borderRadius: '12px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#6b7280' }}>🔄 Loading dashboard data...</h2>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '0' }}>
      <div style={{ 
        background: 'white',
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        marginBottom: '30px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <h1 style={{ 
            color: '#17365D', 
            marginBottom: '0',
            fontSize: '2rem',
            fontWeight: '700'
          }}>
            🎉 Admin Portal Working!
          </h1>
          
          <button 
            onClick={fetchStats} 
            disabled={loading}
            style={{
              padding: '10px 20px',
              backgroundColor: loading ? '#9ca3af' : '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            <FontAwesomeIcon icon={faRefresh} spin={loading} />
            {loading ? 'Refreshing...' : 'Refresh Data'}
          </button>
        </div>
        
        <p style={{ 
          color: '#6b7280', 
          fontSize: '1.1rem', 
          marginBottom: '0' 
        }}>
          Welcome to the StoneForex Admin Dashboard. Manage users, approve deposits, and monitor platform activity.
        </p>
      </div>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
        gap: '20px',
        marginBottom: '30px'
      }}>
        {stats.map((stat, index) => (
          <div key={index} style={{ 
            background: 'white',
            padding: '25px',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            gap: '15px'
          }}>
            <div style={{
              width: '50px',
              height: '50px',
              backgroundColor: stat.color,
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white'
            }}>
              <FontAwesomeIcon icon={stat.icon} size="lg" />
            </div>
            <div>
              <h3 style={{ 
                margin: '0 0 5px 0', 
                color: stat.color,
                fontSize: '1.8rem',
                fontWeight: '700'
              }}>
                {stat.value}
              </h3>
              <p style={{ 
                margin: 0, 
                color: '#6b7280', 
                fontSize: '0.9rem',
                fontWeight: '500'
              }}>
                {stat.title}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminDashboard;
